const backendDomain=process.env.REACT_APP_BACKEND_URL || "http://localhost:8080"

const SummaryApi = {
  forgotPasswordSendOtp:{
    url:`${backendDomain}/api/forgotpassword/send-otp`,
    method:"post"
  },
  forgotPasswordVerifyOtp:{
    url:`${backendDomain}/api/forgotpassword/verify-otp`,
    method:"post"
  },
  payAtStore: {
  url: `${backendDomain}/api/payment/pay-at-store`,
  method: "POST",
},
    //user signin
    signup:{
        url:`${backendDomain}/api/signup`,
        method:"post"
    },
    sendOtp:{
        url:`${backendDomain}/api/send-otp`,
        method:"post"

    },
    verifySignup:{
       url:`${backendDomain}/api/verify-signup`,
       method:"post"
    },
    signin:{
        url:`${backendDomain}/api/signin`,
        method:"post"
    },
    verifyotp:{
        url:`${backendDomain}/api/verify-otp`,
        method:"post"
    },
    loginSendOtp:{
        url:`${backendDomain}/api/login-otp`,
        method:"post"
    },
    updateUserProfile:{
    url:`${backendDomain}/api/update-profile`,
    method:"put"
      
},
getProductByCategory:(id) =>({ 
  url: `${backendDomain}/api/product-category/${id}`,
  method: "get"
}),
getUserProfile:{
    url:`${backendDomain}/api/user-profile`,
    method:"get"

},
addToCart:{
    url:`${backendDomain}/api/cart/add`,
    method:"post"
},
getCart: (userId) => ({
  url: `${backendDomain}/api/cart/${userId}`,
  method: "get",
}),
updateCartItem: (id) => ({
    url: `${backendDomain}/api/cart/update/${id}`,
    method: "put",
  }),
  deleteCartItem: (id) => ({
    url: `${backendDomain}/api/cart/delete/${id}`,
    method: "delete",
  }),
  returnRequest: (orderId) => ({
    url: `${backendDomain}/api/orders/${orderId}/request-return`,
    method: "put",
  }),
  createOrder:{
    url:`${backendDomain}/api/payment/create-order`,
    method:"post"
  },
  //seller side

  sendOtpSeller:{
    url:`${backendDomain}/api/seller/send-otp`,
    method:"post"
},
verifyOtpSeller:{
    url:`${backendDomain}/api/seller/verify-otp`,
    method:"post"
},
uploadProfilePic:{
    url:`${backendDomain}/api/upload-profile-pic`,
    method:"post"
},
deleteProfilePic:{
    url:`${backendDomain}/api/delete-profile-pic`,
    method:"delete"
},
    sellerSignup:{
        url:`${backendDomain}/api/seller/admin-signup`,
        method:"post"
    },
    fetchPincodeDetails: (pincode) => ({
  url: `${backendDomain}/api/seller/pincode/${pincode}`,
  method: "get"
}),
fetchReturnedOrders: {
    url:`${backendDomain}/api/seller/get-returned-orders`,
    method:"get"
},
    sellerLogin:{
        url:`${backendDomain}/api/seller/admin-login`,
        method:"post"
    },
    sellerDashboard:{
        url:`${backendDomain}/api/seller/dashboard`,
        method:"get"
    },
    sellerProfile:{
        url:`${backendDomain}/api/seller/profile`,
        method:"get"
    },
    uploadProduct:{
        url:`${backendDomain}/api/seller/upload-product`,
        method:"post"
    },
    getProducts:{
        url:`${backendDomain}/api/seller/products`,
        method:"get"
    },
  updateProduct: {
  url: `${backendDomain}/api/seller/update-product`,
  method: "put"
},
    updateProfile:{
        url:`${backendDomain}/api/seller/profile`,
        method:"put"
    },
    getOrders:{
        url:`${backendDomain}/api/seller/orders`,
        method:"get"
    },
    generateSellerInvoice: (orderId) => ({
  url: `${backendDomain}/api/seller/orders/${orderId}/invoice`,
  method: "get"
}),

    getStats:{
        url:`${backendDomain}/api/seller/stats`,
        method:"get"
    },
    deleteProduct:
     { 
    url:`${backendDomain}/api/seller/delete-product`, 
     method:"delete" 
    }, 
    fetchProduct:{ 
    url:`${backendDomain}/api/products`, 
    method:"get" 
   },
  getPublicCategories: {
  url: `${backendDomain}/api/categories/public`,
  method: "get",
},
   getCategories: {
    url: `${backendDomain}/api/categories`,
    method: "get",
  },
  addCategory: {
    url: `${backendDomain}/api/categories/add-category`,
    method: "post",
  },
  getAllSellers:{
    url:`${backendDomain}/api/admin/get-sellers`,
    method:"get"
  },
  updateCategory: {
    url: `${backendDomain}/api/categories`, // append /:id in frontend
    method: "put",
  },
  deleteCategory: {
    url: `${backendDomain}/api/categories`, // append /:id in frontend
    method: "delete",
  },
   getCancelledOrders:{
    url:`${backendDomain}/api/orders/cancelled`,
    method:"get",
   },
   getProductById:(id)=>({
    url:`${backendDomain}/api/products/${id}`,
    method:"get"
   }),
cancelOrder: (orderId) => ({
  url: `${backendDomain}/api/orders/cancel/${orderId}`,
  method: "PUT",
}),
uploadSellerProfilePic:{
  url:`${backendDomain}/api/seller/upload-profile`,
  method:"put"
},
deleteSellerProfile:{
  url:`${backendDomain}/seller/delete-profile`,
  method:"delete"
},
platformAdminSignup:{
    url:`${backendDomain}/api/admin/platformadmin-signup`,
    method:"post"
},
platformAdminSignin:{
    url:`${backendDomain}/api/admin/platformadmin-login`,
    method:"post"
},

  getSellerOrders:{
     url:`${backendDomain}/api/orders/get-orders`,
     method:"get"
  },
  getSellerOrdersByStatus:{
    url:`${backendDomain}/api/orders/status/:status`,
    method:"get"
  },
  getPendingOrders:{
    url:`${backendDomain}/api/orders/pending`,
    method:"get",
  },
  getCompletedOrders:{
    url:`${backendDomain}/api/orders/completed`,
    method:"get"
  },
updateOrders: (id) => ({
  url: `${backendDomain}/api/orders/orders/${id}`,
  method: "put",
}),
  verifyPayment:{
    url:`${backendDomain}/api/payment/verify-payment`,
    method:"post"
  },
  getUserOrders:{
    url:`${backendDomain}/api/payment/orders`,
    method:"get"
  },
 getOrderDetails: (orderId) => ({
    url: `${backendDomain}/api/payment/order-details/${orderId}`,
    method: "get"
}),
getAllUsers: {
  url: `${backendDomain}/api/admin/get-users`,
  method: "get",
},
raiseUserQuery:{
    url:`${backendDomain}/api/queries/raise`,
    method:"post"
},
getMyQueries:{
  url:`${backendDomain}/api/queries/my-queries`,
  method:"get"  
},
getRepliedQueries:{
  url:`${backendDomain}/api/queries/replied-queries`,
  method:"get"  
},
replyToSellerResponse:{
  url:`${backendDomain}/api/queries/reply-seller-response`,
  method:"post"  
},
getUserById: {
  url: (id) => `${backendDomain}/api/admin/get-users/${id}`,
  method: "get",
},
getSellerQueries:{
  url:`${backendDomain}/api/queries/get-seller-queries`,
  method:"get"
},
getQueryMessages: (queryId) => ({
  url:`${backendDomain}/api/queries/get-query-messages/${queryId}`,
  method:"get"
}),
replyToQuery:{
  url:`${backendDomain}/api/queries/reply-query`,
  method:"post" 
},
updateUser: {
  url: (id) => `${backendDomain}/api/admin/get-users/${id}`,
  method: "put",
},

deleteUser: {
  url: (id) => `${backendDomain}/api/admin/get-users/${id}`,
  method: "delete",
},


getAdminProfile:{
    url:`${backendDomain}/api/admin/profile`,
    method:"get"
},
updateAdminProfile:{
    url:`${backendDomain}/api/admin/profile`,   
    method:"put"
},
getSellersByStatus: (status) => ({
    url: `${backendDomain}/api/admin/sellers/${status}`, // use URL param
    method: "get"
}),
getUpdateSellerStatus: (id) => ({
    url: `${backendDomain}/api/admin/sellers/${id}`,
    method: "put"
}),
  editSeller: (sellerId) => ({
    url: `${backendDomain}/api/admin/sellers/${sellerId}/edit`,
    method: "put",
  }),
  
  uploadProductByAdmin: (sellerId) => ({
    url: `${backendDomain}/api/admin/sellers/${sellerId}/products`,
    method: "post",
  }),
  updateProductByAdmin :(productId) => ({
  url: `${backendDomain}/api/admin/products/${productId}`,
  method: "put",
}),

getSellerProducts: (sellerId) => ({
    url: `${backendDomain}/api/admin/sellers/${sellerId}/products`,
    method: "get",
  }),

deleteProductByAdmin: (sellerId) => ({
  url: `${backendDomain}/api/admin/products/${sellerId}`,
  method: "delete"
}),
deleteSeller:(sellerId) =>( {
    url: `${backendDomain}/api/admin/delete-seller/${sellerId}`,
    method: "delete",
}),
  
  raiseUserToAdminQuery: {
    url: `${backendDomain}/api/admin-support/users/raise`,
    method: "post",
  },
  getMyUserQueries: {
    url: `${backendDomain}/api/admin-support/users/my-queries`,
    method: "get",
  },

getQueryDetailsToUser: (id) => ({
    url: `${backendDomain}/api/admin-support/users/${id}`,
    method: "get",
  }),

  // Query details
  getQueryDetails: (id) => ({
    url: `${backendDomain}/api/admin-support/admin/${id}`,
    method: "get",
  }),

  // Messages
  addMessage: {
    url: `${backendDomain}/api/admin-support/users/message`,
    method: "post",
  },

  
  getAllUserQueries: {
    url: `${backendDomain}/api/admin-support/admin/all`,
    method: "get",
  },
  replyToUserByAdmin:{
    url:`${backendDomain}/api/admin-support/admin/message`,
    method:"post"
  },
  updateQueryStatus: (id) => ({
    url: `${backendDomain}/api/admin-support/admin/update-status/${id}`,
    method: "put",
  }),
}

export default SummaryApi